export default __webpack_public_path__ + "static/media/film-strip-red-title-background.4aa91356.png";